import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  H1,
  Header,
  Icon
} from '@contently/toolkit';

import InfoModal from './info_modal';

const BriefTemplateWrapper = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const toggleModalIsOpen = () => {
    setModalIsOpen(!modalIsOpen);
  };

  const { children, createForm } = props;

  const headerText = createForm ? 'Create a' : 'Edit your';

  return (
    <article id="brief-template-form">
      <Header>
        <H1>
          {`${headerText} brief template`}
          <Icon onClick={toggleModalIsOpen} type="question-circle" />
        </H1>
      </Header>
      { children }
      <InfoModal
        isOpen={modalIsOpen}
        onCancel={toggleModalIsOpen}
      />
    </article>
  );
};

BriefTemplateWrapper.defaultProps = {
  createForm: false
};

BriefTemplateWrapper.propTypes = {
  createForm: PropTypes.bool,
  children: PropTypes.element.isRequired
};

export default BriefTemplateWrapper;



// WEBPACK FOOTER //
// ./app/javascript/app/components/brief_templates/brief_template_wrapper.jsx